// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'


import Sortable from 'sortablejs' //table 列拖动
// import 'default-passive-events'
import elementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css"
import VueAxios from "vue-axios";
import axios from "axios";
import store from "./store";
import "./style/index.less";

import {logoutApi} from "@/api/work/a_token.js";

import * as echarts from "echarts";

Vue.prototype.$echarts = echarts;

Vue.config.productionTip = false
Vue.prototype.$axios = axios;

// 注册自定义指令 lazy，放在 new Vue 实例化之前
Vue.directive('lazy', {
    bind(el, binding) {
        const img = new Image();
        img.src = binding.value;
        img.onload = () => {
            el.src = binding.value;
        };
    }
});

// 计时器相关逻辑
let timer;

const TEN_MINUTES = 600000;


function autoLogout() {
    if (timer) {
        clearTimeout(timer);
    }
    timer = setTimeout(() => {
        clearToken();
    }, TEN_MINUTES);
}

function clearToken() {
    localStorage.clear();
    window.location.href = 'https://www.vimiu3d.com/manage/login/login';
}

// 添加全局点击事件监听器
document.addEventListener('mousemove', () => {
    autoLogout();
});
document.addEventListener('click', () => {
    autoLogout();
});

//该代码 是为了让el-table 组件 初次点击时为倒序
Vue.directive('sort-orders', {
    inserted: function (el, binding, vnode) {
        const table = vnode.componentInstance;
        const sortOrders = binding.value;
        table.columns.forEach(column => {
            column.sortOrders = sortOrders;
        });
    }
});

//注册element
Vue.use(elementUI)
/* eslint-disable no-new */
new Vue({
    el: "#app",
    router,
    store,
    components: {App},
    template: "<App/>"
});


// WEBPACK FOOTER //
// ./src/main.js